<div class="slider-container">
    <div class="slider" [style.transform]="'translateX(' + currentIndex * -100 + '%)'">
      <div *ngFor="let message of messagesArray" class="slide">
        {{ message }}
      </div>
    </div>
  </div>
